import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { SurveysService } from 'src/app/services/surveys.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-surveys-answer-images',
  templateUrl: './surveys-answer-images.component.html',
  styleUrls: ['./surveys-answer-images.component.scss']
})
export class SurveysAnswerImagesComponent implements OnInit {

  dataImages: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private surveyS: SurveysService,
    private main : MainService
  ) { }

  ngOnInit(): void {
    console.log("ID")
    console.log(this.data)
    this.getImages();
  }

  getImages(){
    this.main.ShowLoading();

    this.surveyS.getImagesAnswer(this.data.id_respuesta).subscribe(
      (result: any) => {
        this.dataImages = result.data;
        this.main.HideLoading();
      },
      (err: any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al obtener imágenes',
          text: 'Ocurrió un error al obtnener las imágenes, por favor vuelve a intentarlo.'
        });
      }
    );

  }

}
